import { useEffect, useRef, useState } from "react";

/**
 * Triggers `inView=true` once the element scrolls into the viewport.
 * Stays true after first intersection (no re-trigger on scroll up).
 */
export const useInView = ({
  threshold = 0.15,
  rootMargin = "0px 0px -10% 0px",
} = {}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold, rootMargin }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [threshold, rootMargin]);

  return [ref, inView];
};

export default useInView;
